export enum ArchImpressionType {
  LOWER,
  UPPER,
}
